export const MAX_CATEGORY_DEPTH = 4;
